// 缓存数据keys
export const CACHE_KEYS = {
  // 页面detail数据
  DETAIL: 'activityDetail',
  // 选中场次,
  SELECTED_SCENE: 'selectedScene'
};

// 按钮状态
export const REG_STATUS = {
  // 可报名
  registrable: 1,
  // 报名已满
  full: 2,
  // 报名未开始
  before_registering: 3,
  // 报名已结束
  after_registering: 4,
  // 活动进行中
  started: 5,
  // 活动已结束
  expired: 6
};

export const MTA_KEYS = {
  pageView: 'KeyPageView',
  share: 'Share'
};

export const SHARE_PLAT = {
  nio: 'niofriend',
  wb: 'weibo',
  weibo: 'weibo',
  wx: 'wechatfriend',
  timeline: 'wechatcircle'
};